import {ThemeProvider} from '@mui/material'
import {AuthInit} from '_component/modules/auth'
import NoticeModal from '_component/modules/notice/NoticeModal'
import {I18nProvider} from '_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '_metronic/layout/core'
import {MasterInit} from '_metronic/layout/MasterInit'
import {Suspense, useEffect, useRef} from 'react'
import {useSelector} from 'react-redux'
import {Outlet, useNavigate} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {newVersionAlert} from 'utils/CustomAlert/Alert'
import {theme} from 'utils/designSytem/customMui'

const App = () => {
  const navigate = useNavigate()
  const userInfo = useSelector((state: any) => state?.userInfo?.userInfo)
  const titleName =
    process.env.REACT_APP_CUSTOM_TITLE || '미터리움 - 스마트 디지털 이미지 원격검침 시스템'
  if (process.env.NODE_ENV === 'production') {
    console.log = function no_console() {}
    console.warn = function no_console() {}
    console.info = function no_console() {}
    console.error = function no_console() {}
  }
  if (process.env.NODE_ENV === 'development') {
    console.warn = function no_console() {}
  }

  useEffect(() => {
    document.title = titleName
    if (
      !userInfo &&
      window.location.pathname !== '/auth' &&
      window.location.pathname !== '/join/agree' &&
      window.location.pathname !== '/join/registration' &&
      window.location.pathname !== '/password/certification' &&
      window.location.pathname !== '/password/reset'
    ) {
      navigate('/auth')
    }
  }, [titleName, userInfo, navigate])

  const lastHashRef = useRef('')

  useEffect(() => {
    const timeoutRef = {current: null as NodeJS.Timeout | null}
    const interval = setInterval(async () => {
      try {
        const res = await fetch(`/meta.json?ts=${Date.now()}`) // 캐시 방지용
        const json = await res.json()
        if (lastHashRef.current && json.hash !== lastHashRef.current) {
          let confirmed = false

          timeoutRef.current = setTimeout(() => {
            if (!confirmed) window.location.reload()
          }, 5000)

          const result = await newVersionAlert()
          if (result) {
            confirmed = true
            if (timeoutRef.current) clearTimeout(timeoutRef.current)
            window.location.reload()
          }
        }

        lastHashRef.current = json.hash
      } catch (err) {
        console.error('❌ meta.json fetch error:', err)
      }
    }, 300000)

    return () => clearInterval(interval)
  }, [])

  return (
    <>
      <Suspense fallback={<LayoutSplashScreen />}>
        <ThemeProvider theme={theme}>
          <I18nProvider>
            <LayoutProvider>
              <AuthInit>
                <Outlet />
                <MasterInit />
              </AuthInit>
            </LayoutProvider>
          </I18nProvider>
        </ThemeProvider>
      </Suspense>
      {/* 공지는 로그인 전후를 가리지 않고 떠야 하므로 라우트 바깥에 둔다.
          문구·일정은 서버의 /config/notice-config.json 에서 읽는다 (재배포 불필요) */}
      <NoticeModal />
      <ToastContainer />
    </>
  )
}

export {App}
